'use client';

import { Link } from 'react-router-dom';

import { IconButtonLinkStyled } from './styled';
import { IconButtonLinkProps } from './types';

export const IconButtonLink = (props: IconButtonLinkProps) => {
  return <IconButtonLinkStyled component={Link} {...props} />;
};
